module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "1200px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.conciliation_imports_process) ? _c('div', {
    staticClass: "content"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.conciliation_imports_process), function(conciliation) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(conciliation.line))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(conciliation.service))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(conciliation.payment_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(conciliation.message))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.xls
    }
  }, [_vm._v("Export XLS")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(false)
      }
    }
  }, [_vm._v("Cancel")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Conciliation Process")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Line")]), _vm._v(" "), _c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v("Payment")]), _vm._v(" "), _c('th', [_vm._v("Message")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cccb04fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/V2/payment/PaymentConciliationProcess.vue
// module id = 1193
// module chunks = 39